var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLandingHeroCut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 207,
    viewBox: "0 0 1440 207",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1444 207V0C1347.88 99.6044 1212.9 152.004 1074.75 143.334L495.65 106.99C384.477 100.013 272.89 103.805 162.448 118.314L0 139.655V185V207H1444Z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingHeroCut);
export default __webpack_public_path__ + "static/media/landing_hero_cut.e28bfbbcc8cc13bccc8920f0665cc369.svg";
export { ForwardRef as ReactComponent };